import React, { useEffect, useRef, useState } from 'react'
import './Home.css'
import Topnav from './Topnav/Topnav'
import navimg from '../../img/more.png'
import shareimg from '../../img/share.png'
import Gamelist from './Gamelist/Gamelist'
import fd_png from '../../img/search_1.png'
import Banner from './Banner/Banner'
import { getHomedata } from '../../api'
import starsScore from '../../method/start'
import { insert_adv, remove_adv } from '../../method/addadv'
import Footer from './Footer/Footer'
import Share from './Share/Share'
import hostName from '../../method/hostname'
import { iframeLoad } from '../../method/analytics'

export default function Home() {
  // const navigate = useNavigate()
  const [populargames, setPopulargames] = useState([])
  const [hotgame, setHotgame] = useState([])
  const [gamelist, setGamelist] = useState([])
  const [gamecata, setGameata] = useState([])

  // 请求首页数据
  const gethomedata = () => {
    getHomedata().then(res => {
      /* console.log(res.data); */
      setPopulargames(res.data.populargames)
      setHotgame(res.data.hotgames)
      setGamelist(res.data.newgames)
      setGameata(res.data.category)
    })
  }

  useEffect(() => {
    gethomedata()

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      // 广告加载 上传分析
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [])

  /* 跳转详情页 */
  /* const godeta = (para) => {
    window.location = "/page/details?gid=" + para
  } */

  /* 左上角导航控制 */
  const [flag, setFlag] = useState(false)
  const Navlist = () => {
    setFlag(true)
  }
  /* 右上角分享控制 */
  const [share, setShare] = useState(false)
  const setshare = () => {
    share ? setShare(false) : setShare(true)
  }

  // 判断view是否可以滚动
  flag ? (document.getElementsByTagName('body')[0].style.overflowY = 'hidden') : (document.getElementsByTagName('body')[0].style.overflowY = 'auto')

  /* 搜索框 */
  const iptref = useRef()
  /* 回车 */
  const goSearch = e => {
    let keycode = e.keyCode
    if (keycode === 13 && iptref.current.value !== '') {
      window.location = '/page/search?words=' + iptref.current.value
    }
  }
  /* 点击放大镜 */
  const gosearch = () => {
    if (iptref.current.value !== '') {
      window.location = '/page/search?words=' + iptref.current.value
    }
  }

  const setflag = () => {
    setFlag(false)
  }

  return (
    <div className="home">
      {/* head */}
      <header>
        <img src={navimg} className="img-nav" onClick={Navlist} alt="" />
        <h1> {hostName}</h1>
        <img src={shareimg} alt="" className="img-share" onClick={setshare} />
      </header>

      {/* nav */}
      <Topnav flag={flag} setflag={setflag} gamecata={gamecata}></Topnav>
      <Share flag={share} setshare={setshare}></Share>

      {/* search */}
      <nav>
        <div className="top-search">
          <input type="search" onKeyUp={goSearch} ref={iptref} placeholder="search" />
          <img src={fd_png} alt="" onClick={gosearch} />
        </div>
      </nav>
      {/* 广告一 */}
      <div className="adv_box">
        <p>Advertisement</p>
        <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
      </div>

      {/* popular */}
      <ul>
        <li>
          <h1>Popular Recommend</h1>
          <ul className="po-con">
            {populargames?.map(item => (
              <li key={item.gid}>
                <a href={'/page/details?gid=' + item.gid}>
                  <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                  <h2>{item.name}</h2>
                  <p>
                    {starsScore(item.score)} {item.score}
                  </p>
                </a>
              </li>
            ))}
          </ul>
        </li>

        {/* hotgames */}
        <li>
          <h1>Hot Games</h1>
          <div className="hot-content">
            <Banner hotgame={hotgame}></Banner>
          </div>
        </li>

        {/* 广告二 */}
        <li className="adv_box">
          <p>Advertisement</p>
          <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
        </li>

        {/* newgame */}
        <li>
          <Gamelist gamelist={gamelist}></Gamelist>
        </li>
      </ul>

      <Footer></Footer>
    </div>
  )
}
